// @ts-nocheck

export const JsonRpcApiMethodNames = Object.freeze({
  GET_FUTURE_ODDS: 'GetFutureOdds',
  GET_ODDS: 'GetOdds',
});

export const WAPIMethodNames = Object.freeze({
  REALTIY_CHECK_CONFIRM_ACTIVITY: 'ConfirmActivity',
});
